const TENANT_CHANNEL_NAME = "tenant-switch-channel";
const TENANT_CHANGE_EVENT = "tenant-changed";

let broadcastChannel: BroadcastChannel | null = null;

export const initTenantSync = (onTenantChanged: () => void): (() => void) => {
  if (typeof BroadcastChannel === "undefined") {
    console.warn("BroadcastChannel API is not supported in this browser");
    return () => {};
  }

  broadcastChannel = new BroadcastChannel(TENANT_CHANNEL_NAME);

  broadcastChannel.onmessage = (event) => {
    if (event.data?.type === TENANT_CHANGE_EVENT) {
      console.log("Tenant changed in another tab, logging out...");
      onTenantChanged();
    }
  };

  return () => {
    if (broadcastChannel) {
      broadcastChannel.close();
      broadcastChannel = null;
    }
  };
};

export const broadcastTenantChange = (): void => {
  if (!broadcastChannel) {
    console.warn("Broadcast channel not initialized");
    return;
  }

  try {
    broadcastChannel.postMessage({
      type: TENANT_CHANGE_EVENT,
      timestamp: Date.now(),
    });
    console.log("Tenant change broadcasted to other tabs");
  } catch (error) {
    console.error("Failed to broadcast tenant change:", error);
  }
};
